import { render, staticRenderFns } from "./LoginSignIn.vue?vue&type=template&id=1942db22&"
import script from "./LoginSignIn.vue?vue&type=script&lang=js&"
export * from "./LoginSignIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports